import React, { Component } from "react";

class Contact extends Component {
  state = { status: "idle", errorMessage: "" };

  handleSubmit = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    const name = String(form.elements.namedItem("name")?.value || "").trim();
    const email = String(form.elements.namedItem("email")?.value || "").trim();
    const subject = String(form.elements.namedItem("subject")?.value || "").trim();
    const message = String(form.elements.namedItem("message")?.value || "").trim();
    this.setState({ status: "sending", errorMessage: "" });

    try {
      const endpoint = new URL("/api/contact", window.location.href).toString();
      const response = await fetch(endpoint, {
        method: "POST",
        mode: "same-origin",
        credentials: "same-origin",
        cache: "no-store",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name, email, subject, message }),
      });

      if (!response.ok) {
        const result = await response.json().catch(() => ({}));
        throw new Error(result.error || `Unable to send message (HTTP ${response.status}).`);
      }

      form.reset();
      this.setState({ status: "success" });
    } catch (error) {
      this.setState({
        status: "error",
        errorMessage: error.message || "The request failed. Please try again or email me directly.",
      });
    }
  };

  render() {
    if (!this.props.data) return null;

    return (
      <section id="contact" className="contact-section">
        <div className="section-title"><h2>Contact</h2></div>
        <p className="contact-intro">Have a project in mind, a role to discuss, or just want to say hello? Send me an email via this form or email me directly at <a href="mailto:me@michaylabenezra.com">me@michaylabenezra.com</a>.</p>
        <div className="contact-body">
          <div className="contact-copy">
            <div className="contact-icon" aria-hidden="true">
              <i className="fa-solid fa-envelope contact-envelope"></i>
            </div>
          </div>
          <form className="contact-form" onSubmit={this.handleSubmit}>
            <div className="contact-field-row">
              <label htmlFor="contact-name">Name
                <input id="contact-name" name="name" type="text" placeholder="Your name" autoComplete="name" maxLength="100" required />
              </label>
              <label htmlFor="contact-email">Email
                <input id="contact-email" name="email" type="email" placeholder="you@example.com" autoComplete="email" maxLength="254" required />
              </label>
            </div>

            <label htmlFor="contact-subject">Subject
              <input id="contact-subject" name="subject" type="text" placeholder="What can I help with?" maxLength="150" required />
            </label>

            <label htmlFor="contact-message">Message
              <textarea id="contact-message" name="message" rows="5" placeholder="Tell me about your project..." maxLength="2000" required />
            </label>

            <button type="submit" disabled={this.state.status === "sending"}>{this.state.status === "sending" ? "Sending..." : "Send message"}</button>
            {this.state.status === "success" && <p className="form-status" role="status">Message sent. Thank you.</p>}
            {this.state.status === "error" && <p className="form-status form-status-error" role="alert">{this.state.errorMessage} Please email <a href="mailto:me@michaylabenezra.com">me@michaylabenezra.com</a> directly if the problem continues.</p>}
          </form>
        </div>
      </section>
    );
  }
}

export default Contact;
